/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { SubscriptionDestroyPathParams, SubscriptionDestroyResponse } from '../types/SubscriptionDestroy'

/**
 * DELETE /:organisation/profiles/:profile/subscription
 * @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::destroy
 */
export async function subscriptionDestroy(
	organisation: SubscriptionDestroyPathParams['organisation'],
	profile: SubscriptionDestroyPathParams['profile'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<SubscriptionDestroyResponse>> {
	return axiosInstance.delete(`/${organisation}/profiles/${profile}/subscription`, config)
}
